import { type MutationError, trpc } from '@/shared/api';

interface UseDeleteExhibitionPurposeOptions {
  readonly onSuccess?: () => void;
}

/** 목적과 그 아래 기획전·상품 연결·S3 이미지를 함께 지운다. 확인창은 호출부가 띄운다. */
export const useDeleteExhibitionPurpose = ({
  onSuccess,
}: UseDeleteExhibitionPurposeOptions = {}) => {
  const mutation = trpc.productManagement.exhibitionPurposes.delete.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    deletePurpose: (id: string) => mutation.mutate({ id }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 목적 배너의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
